<template>
	<dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
        <template v-slot:title>{{report.name || report.report_name}}</template>
        <template v-slot:content>
            <div class = 'py-3' v-if = 'report.active'>Архивировать отчет?</div>
            <div class = 'py-3' v-else>Разархивировать отчет?</div>
        </template>
        <template v-slot:action>
			<v-btn class = 'px-0 red--text text--darken-2' :loading = 'indicator' block depressed @click = 'archiveReport'>
				Применить
			</v-btn>
		</template>
    </dialog-generic>
</template>

<script>
	import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

	export default {
		name: 'ReportArchiveDialog',
		props: ['initialState', 'data', 'postAction'],
		components: {'dialog-generic': DialogGeneric},
		data() {
			return {
				visibility: this.initialState,
				report: this.data,
				indicator: false,
			}
		},
		 watch: {
	        initialState(value) {
	            this.visibility = value
	        },
	        visibility(value) {
	            this.$emit('update:initialState', value);
	        },
	        data(value) {
	            this.report = value
	        }
	    },
		methods: {
			archiveReport() {
                this.indicator = true
                this.report.active = this.report.active == 1? 0: 1
		        let requestData = {
		          'login': this.$store.getters.userLogin,
		          'report_id': this.report.report_id
                }
		        this.$http.put(this.$store.getters.endpoint + '/db/reports',
		          { ...requestData, ...this.report },
		          {headers: this.$store.state.restrictedHeaders}
		        ).then( (r) => {
					this.postAction('reports')
					this.$dataLayer.$emit('enrich', {
                        event: 'crud',
                        data: {
                            type: 'archive',
                            target: 'report'
                        },
                        once: false
                    })
		        	this.visibility = false
		        	this.indicator = false
		        });
			}
		}
	}
</script>